import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import PlusIcon from "../../assets/icons/Icon_Library/application icons/general/add_circle.svg2";

function AddAddress() {
  return (
    <div className="align-items-center rounded-3 mt-4 p-4 bg-purple-gradient-darker-reverse">
      <div className="ms-2">
        <span className="fs-4 fw-bold "> Add Address</span>
      </div>
      <div className="text-secondary ms-2">
        Provide one or more addresses for sending alerts or data.
      </div>
      <div className="ms-3 my-3">
        <div>
          <Form.Group as={Row} className="mb-3" controlId="addAddress">
            <Form.Label className="fw-bold">
              {" "}
              <PlusIcon width={25} className="me-2" />
              Add address :
            </Form.Label>
            <Col sm="10" className="p-2">
              <Form.Control type="textarea" />
            </Col>
          </Form.Group>
        </div>
        <div>
          <Form.Group as={Row} className="mb-3" controlId="addMultipleAddress">
            <Form.Label className="fw-bold">
              <PlusIcon width={25} className="me-2" />
              Add multiple addresses:
            </Form.Label>
            <Col sm="10">
              <Form.Control type="textarea" />
            </Col>
          </Form.Group>
        </div>
        <div>
          <Form.Group as={Row} className="mb-3" controlId="addUrgency">
            <Form.Label className="fw-bold">
              <PlusIcon width={25} className="me-2" />
              Add Urgency:
            </Form.Label>
            <Col sm="10">
              <Form.Control type="textarea" />
            </Col>
          </Form.Group>
        </div>
      </div>
    </div>
  );
}

export default AddAddress;
